import { render, staticRenderFns } from "./ConfirmInAppPurchase.vue?vue&type=template&id=1b818c2b&scoped=true"
import script from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts"
export * from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmInAppPurchase.vue?vue&type=style&index=0&id=1b818c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b818c2b",
  null
  
)

export default component.exports